import React from "react";
import { Rocket, TrendingUp, ArrowRightLeft, Coins } from "lucide-react";

const STEPS = [
  { icon: Rocket, title: "1. Launch a coin", text: "Pick a name, symbol, logo and description. It costs 0.05 SUI to deploy on the Sui bonding curve. No coding, no liquidity needed." },
  { icon: TrendingUp, title: "2. Trade on the curve", text: "Anyone can buy and sell instantly against the bonding curve. Price rises as more SUI is deposited. Every trade pays a 1% fee." },
  { icon: Coins, title: "3. Fees split automatically", text: "The 1% trade fee splits 70/30: 0.7% dev reward (paid to the coin's creator wallet) and 0.3% platform fee." },
  { icon: ArrowRightLeft, title: "4. Migrate to Cetus at 7,500 SUI", text: "Once the curve collects 7,500 SUI, liquidity auto-deploys to a Cetus AMM pool and the LP is burned. Trading continues on Cetus." },
];

export default function HowItWorks() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10">
      <h1 className="font-display font-extrabold text-4xl mb-3">How it <span className="gradient-text">works</span></h1>
      <p className="text-muted-foreground mb-8">SuiPads is a fair-launch memecoin launchpad on Sui. No presale, no team allocation — just a bonding curve that graduates to Cetus.</p>
      <div className="space-y-4">
        {STEPS.map((s) => {
          const Icon = s.icon;
          return (
            <div key={s.title} className="card-surface p-5 flex gap-4">
              <div className="w-11 h-11 rounded-xl flex items-center justify-center shrink-0" style={{ background: "linear-gradient(135deg,#7CF24E,#1EC62E)" }}>
                <Icon className="w-5 h-5 text-black" />
              </div>
              <div>
                <h3 className="font-display font-bold">{s.title}</h3>
                <p className="text-sm text-muted-foreground mt-1">{s.text}</p>
              </div>
            </div>
          );
        })}
      </div>
      <div className="card-surface p-5 mt-6 border-[#FFB800]/30">
        <h3 className="font-display font-bold text-[#FFB800] mb-1">Current status: Mainnet, contracts ready to publish</h3>
        <p className="text-sm text-muted-foreground">The Sui Move smart contracts (launchpad, bonding curve, 1% fee split 70/30, 7,500-SUI graduation, migration hand-off, and read-only quote functions) are written and available in <b>/contracts</b> with tests and deploy instructions. They must be tested, audited and published on-chain by you (a funded deployer + `sui client publish`) — this cannot be done from the app builder. Wallet connection and SUI balances shown here are already <b>live on Sui mainnet</b>. Once the package is published and its IDs shared, on-chain create/buy/sell/migrate and the live indexer get wired in — no simulated trades.</p>
      </div>
    </div>
  );
}
